module.exports = __webpack_public_path__ + "assets/6c0a75dc5671c3f237a79f6e45b9891c.js";